import React from "react";
//#region redux
//#endregion
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { UpdateBoardMembersDataMoreActionProps } from "models/propTypes/boardMemberPropTypes";
//#endregion
//#region components
import { MoreActions } from "components/common";
import { useUpdateBoardMembersDataSnoozeAction } from "components/boardMember";
//#endregion

const UpdateBoardMembersDataMoreActions: React.FC<UpdateBoardMembersDataMoreActionProps> = (props) => {
  const snoozeAction = useUpdateBoardMembersDataSnoozeAction(0, props.markAsDoneHandler!);

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    actions.push(snoozeAction);
    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={props.disableSuccessMessages} />;
};

export default UpdateBoardMembersDataMoreActions;
